module.exports = __webpack_public_path__ + "img/plus.2a46db33.svg";